import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from './Title';
import { blue_pilu, white_pilu } from '../../../helpers/utils';

export default function TableTemplate({
	name = '',
	columns = [],
    keys = [],
	rows = [],
}) {
	return (
		<React.Fragment>
			<Title>{name}</Title>
			<Table size='small'>
				<TableHead>
					<TableRow
						style={{
							backgroundColor: blue_pilu,
						}}
					>
						{columns.map((item, index) => (
							<TableCell
								key={index}
								style={{ color: white_pilu }}
							>
								{item}
							</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{rows.map((row, index) => {
                        // const allValuesAreNull = Object.values(row).every(value => value === null);
                        const hasNonNullValue = Object.values(row).some(value => value === null);

                        // Do not render the row if one value is null
                        if (hasNonNullValue) {
                          return null;
                        }

						return (
                            <TableRow key={index}>
                                {keys.map((key, index) => (
                                    <React.Fragment key={index}>
                                        {row[key] && <TableCell>{row[key]}</TableCell>}
                                    </React.Fragment>
                                ))}
                            </TableRow>
                        );
                    })}
				</TableBody>
			</Table>
		</React.Fragment>
	);
}
